<div class="container">
  <div class="row">
    <div [ngClass]="dateSlotClasses">
      <h4 class="caption-slot">{{'Delivery date' | translate}}</h4>
      <app-time-slot-date-selector (nextDayClick)="nextDayClick()" (prevDayClick)="prevDayClick()"
        (updatedBookingSlotEvent)="onUpdatedBookingSlotEvent()" [selectedDate]="selectedDate"
        [calendarService]="bookingSlotStateService" [displayDateFormat]="displayDateFormat" [showSelectDateDialog]="canShiftDate">
      </app-time-slot-date-selector>
    </div>
    <div [ngClass]="timeSlotClasses">
      <h4 class="caption-slot">{{'Delivery time' | translate}}</h4>
      <app-time-slot-selector (updatedBookingSlotEvent)="onUpdatedBookingSlotEvent()"></app-time-slot-selector>
    </div>
    <div *ngIf="pickupPointGroupsExist" class="pickup-pointers mt-3 mt-lg-0 col-sm-6 col-md-6 col-lg-6 col-xga-3">
      <h4 class="caption-slot">{{'Location' | translate}}</h4>
      <app-dropdown-list [items]="pickUpPointGroupItems" [shortText]='true' [(ngModel)]="selectedPickupPointGroupId"></app-dropdown-list>
      <hr>
    </div>
    <div *ngIf="pickupPointsExist" [ngClass]="pickuPointClasses">
      <h4 class="caption-slot">{{'Transfer point' | translate}}</h4>
      <app-dropdown-list [items]="pickUpPointerItems" [shortText]='true' [(ngModel)]="selectedPickupPointId"></app-dropdown-list>
      <hr>
    </div>
  </div>
</div>
